import NewApplicationPage from "@/components/screens/application/new";

export default function NewApplication() {
  return <NewApplicationPage />;
}
